import { render } from "./DesktopView.vue?vue&type=template&id=381abdd3"
import script from "./DesktopView.vue?vue&type=script&lang=js"
export * from "./DesktopView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__